module.exports = __webpack_public_path__ + "img/classify-item1-active.efae2fbe.png";